<template>
<div class='ppj-spinner' :style="{width: `${size}px`, height: `${size}px`}">
  <div class='ppj-spinner-content' :style="{width: `${percentage}%`, height: `${percentage}%`, top: `${50 - 0.5 * percentage}%`, left: `${50 - 0.5 * percentage}%`}">
    <span class='ppj-text'>{{text}}</span>
  </div>
</div>
</template>

<script>
export default {
  props: {
    size: {
      type: Number,
      default: 180
    },
    text: {
      type: String
    },
    percentage: {
      type: Number,
      default: 100
    }
  }
}
</script>

<style lang="scss" scoped>
// custom spinner
.ppj-spinner {
    position: relative;
    overflow: hidden;
    margin: 0 auto;

    .ppj-spinner-content {
        position: absolute;
        color: $color-primary;
        border-radius: 50%;
        box-shadow: inset 0 0 0 1em;
        transform: translateZ(0);
        &:after,
        &:before {
            width: 55%;
            height: 110%;
            top: -5%;
            position: absolute;
            background: $color-white-base;
            content: '';
        }
        &:before {
            left: -5%;
            transform-origin: 100% 50%;
            animation: spinner 2s infinite ease 1.5s;
        }
        &:after {
            left: 55%;
            transform-origin: 0 50%;
            animation: spinner 2s infinite ease;
        }

        .ppj-text {
            color: $font-color-base;
            z-index: 2;
            position: absolute;
            left: 0;
            text-align: center;
            width: 100%;
            top: 40%;
            font-weight: $font-weight-border;
            font-size: $font-size-large;
        }
    }
}
</style>



// WEBPACK FOOTER //
// spinner.vue?2ffb66eb